import script from "./NotificationCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotificationCard.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__